import { Box } from "@mantine/core";

export const Logo = ({ sx = {}, white = false }) => {
  return (
    <Box sx={sx}>
      <img
        src={white ? "/img/ci/logo-white.png" : "/img/ci/logo-color.png"}
        alt="logo"
        style={{ maxWidth: "300px", maxHeight: "100%", height: "100%", objectFit: "contain" }}
      />
    </Box>
  );
};
